import $ from 'jquery';
import debounce from './utils/debounce';

class Tooltip {
    constructor (mobileBreakpoint) {
        this.$document = $(document);
        this.$window = $(window);
        this.$tooltip = $('.js-tooltip');
        this.$tooltipBox = $('.js-tooltip-definition');
        this.$tooltipTerm = $('.js-tooltip-term');
        this.mobileBreakpoint = mobileBreakpoint;
        this.$contentColumn = $('.js-chapter');

        this.$window.on('resize', debounce(() => {
            this.resetTooltip();
        }, 300)).on('load', () => {
            this.$tooltipTerm.on('click', $.proxy(this.positionTooltip, this));
            this.$document.on('click', $.proxy(this.documentClick, this));

        }).on('scroll', () => {
            this.resetTooltip();
        });

        // Escape Key
        this.$document.keyup((e) => {
            if (e.keyCode === 27) {
                this.resetTooltip();
            }
        });
    }

    positionTooltip (e) {
        const $elem = $(e.currentTarget);
        const $tooltipBox = $elem.parent().find('.js-tooltip-definition');
        const contentColumnWidth = this.$contentColumn.width();
        const tooltipHeight = $tooltipBox.outerHeight();
        const tooltipLeftPosMobile = $tooltipBox.offset().left - 16; // 16 is mobile gutter width

        // Make visible and add top position based on height of the tooltip
        if (!$tooltipBox.hasClass('is-visible')) {
            $tooltipBox.addClass('is-visible').css('top', -tooltipHeight);
        } else {
            this.resetTooltip();
        }

        // Add a class based on whether the tooltip text is on the left or right of the page
        if ($elem.parent('.js-tooltip').position().left > (contentColumnWidth / 2)) {
            $elem.parent('.js-tooltip').addClass('is-on-right');
        } else {
            $elem.parent('.js-tooltip').addClass('is-on-left');
        }

        // Make the tooltip correctly positioned on mobile so it's full width and aligned to the left
        if (this.$window.width() < this.mobileBreakpoint) {
            $tooltipBox.css('margin-left', -tooltipLeftPosMobile);
        }
    }

    resetTooltip () {
        this.$tooltipBox.removeClass('is-visible');
        this.$tooltipBox.removeAttr('style');
        this.$tooltip.removeClass('is-clicked is-on-left is-on-right');
    }

    documentClick (e) {
        const $elem = $(e.target);

        if (!$elem.closest(this.$tooltipTerm).length && !$elem.closest(this.$tooltipBox).length) {
            this.resetTooltip();
        }
    }
}

export default Tooltip;
